import script from "./showVipModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./showVipModal.vue?vue&type=script&setup=true&lang=ts"

import "./showVipModal.vue?vue&type=style&index=0&id=54a4fc39&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54a4fc39"]])

export default __exports__